export const SET_NEXT_PATH = 'SET_NEXT_PATH';
export const CLEAR_NEXT_PATH = 'CLEAR_NEXT_PATH';
